export default __webpack_public_path__ + "static/media/ropsten.fd34c5f7.png";